module.exports = __webpack_public_path__ + "img/articlesofassociation.ac5da7c1.jpg";